import i18nMain from './vi/i18nMain';
import i18nValidate from './vi/i18nValidate';
import i18nTable from './vi/i18nTable';
import i18nCommon from './vi/i18nCommon';
import i18nEnum from './vi/i18nEnum';
import i18nComponent from './vi/i18nComponent';
import i18nColumn from './vi/i18nColumn';
import i18nPages from './vi/i18nPages';
import i18nColumnTemplate from './vi/i18nColumnTemplate';
import i18nBaseForm from './vi/i18nBaseForm';
import i18nEmployee from './vi/i18nEmployee';
import i18nEmployeeType from './vi/dictionary/i18nEmployeeType';
import i18nInventoryItem from './vi/dictionary/i18nInventoryItem';
import i18nAccountingObject from './vi/dictionary/i18nAccountingObject';
import i18nTypeOfFund from './vi/dictionary/i18nTypeOfFund';
import i18nReport from './vi/i18nReport';
import i18nBudgetChapter from './vi/dictionary/i18nBudgetChapter';
import i18nStatistic from './vi/dictionary/i18nStatistic';
import i18nPurchasePurpose from './vi/dictionary/i18nPurchasePurpose';
import i18nAccountTransfer from './vi/dictionary/i18nAccountTransfer';
import i18nStock from './vi/dictionary/i18nStock';
import i18nAutoBusiness from './vi/dictionary/i18nAutoBusiness';
import i18nAccountingObjectCategory from './vi/dictionary/i18nAccountingObjectCategory';
import i18nInvoiceFormNumber from './vi/dictionary/i18nInvoiceFormNumber';
import i18nVoucherType from './vi/dictionary/i18nVoucherType';
import i18nProject from './vi/dictionary/i18nProject';
import i18nTopic from './vi/dictionary/i18nTopic';
import i18nDefaultAccount from './vi/dictionary/i18nDefaultAccount';
import i18nSalaryScale from './vi/dictionary/i18nSalaryScale';
import i18nOpeningAccountEntry from './vi/dictionary/i18nOpeningAccountEntry';
import i18nFixedAsset from './vi/dictionary/i18nFixedAsset';
import i18nMonitor from './vi/monitor/i18nMonitor';
import i18nHelpLink from './vi/i18nHelpLink';
import i18nNotification from './vi/i18nNotification';
import i18nNumber from './vi/i18nNumber';
import i18nOpeningSupplyEntry from './vi/dictionary/i18nOpeningSupplyEntry';

export default {
  vi: { 
    i18nMain,
    i18nValidate,
    i18nCommon,
    i18nComponent,
    i18nEnum,
    i18nColumn,
    i18nPages,
    i18nBaseForm,
    i18nColumnTemplate,
    i18nEmployee,
    i18nEmployeeType,
    i18nTable,
    i18nInventoryItem,
    i18nAccountingObject,
    i18nReport,
    i18nBudgetChapter,
    i18nTypeOfFund,
    i18nStatistic,
    i18nPurchasePurpose,
    i18nAccountTransfer,
    i18nStock,
    i18nAutoBusiness,
    i18nAccountingObjectCategory,
    i18nInvoiceFormNumber,
    i18nVoucherType,
    i18nProject,
    i18nTopic,
    i18nDefaultAccount,
    i18nSalaryScale,
    i18nOpeningAccountEntry,
    i18nFixedAsset,
    i18nMonitor,
    i18nHelpLink,
    i18nNotification,
    i18nNumber,
    i18nOpeningSupplyEntry,
  },
};
